import { useMutation } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { api_agent_video_recommendation_path } from '@/utils/routes';

export interface VideoRecommendationCard {
  title: string;
  description: string;
  channel_title: string;
  reason: string;
  video_url: string;
  thumbnail_url: string;
}

interface TriggerVideoRecommendationParams {
  session_id: string;
  exclude_video_urls?: string[];
}

export const useTriggerVideoRecommendation = () =>
  useMutation({
    mutationFn: async ({
      session_id,
      exclude_video_urls = [],
    }: TriggerVideoRecommendationParams) =>
      falconClient.post(api_agent_video_recommendation_path(), {
        session_id,
        exclude_video_urls,
      }),
  });
